<template>
  <div class="home">
    <who-are-you-screening />
  </div>
</template>

<script>
export default {
  middleware: 'auth',
  name: 'Home',
  components: {
    'who-are-you-screening': () => import(/* webpackPrefetch: true */ /* webpackChunkName: "who-are-you-screening" */ '../components/WhoAreYouScreening')
  }
}
</script>
